export default {
  data() {
    return {
      addRightVisible: false,
    }
  },
  methods: {
    onCreateRight(data) {
      return this.$store.dispatch('app/createRight', data)
        .then((res) => {
          const mRes = Array.isArray(res) ? res[0] : res
          if (mRes.data.rows[0].error) {
            this.$toast(this.$t('rights.addForm.error', mRes.data.rows[0].error))
          } else {
            this.$toast(this.$t('rights.addForm.done'));
          }
        })
    },
  }
}